module.exports = __webpack_public_path__ + "static/welcomeplaque-d2ed4313cff52f94694dc8b9d8290c43.jpeg";